module.exports = __webpack_public_path__ + "b5be7bc26695749b9ad707377142b4b9.svg";